/** Marker-style brand strip — dark inky background with bright dots. */
import { SunDoodle, Star } from "./Illustrations";

const PHRASES = [
  "Made for little adventures",
  "Polarized • 100% UV • Light as air",
  "Built for play, not display",
  "Designed for Indian kids",
  "Shipping charges extra, as applicable",
];

export default function BrandStrip() {
  // The marquee needs the phrase list twice for a seamless -50% loop.
  const items = [0, 1].flatMap((copy) => PHRASES.map((p, j) => ({ p, copy, i: copy * PHRASES.length + j })));
  return (
    <section className="brand-strip overflow-hidden py-3.5 border-y border-[#FAFAF7]/15" data-testid="brand-strip" aria-hidden>
      <div className="marquee-track">
        {items.map(({ p, copy, i }) => (
          <div key={`${copy}-${p}`} className="flex items-center gap-4 mx-7 whitespace-nowrap text-[13px] font-medium tracking-[0.04em]">
            <SunDoodle size={18} color={i % 3 === 0 ? "#F4C734" : i % 3 === 1 ? "#8BC547" : "#DD2E20"} />
            <span>{p}</span>
            <Star size={10} color={i % 3 === 0 ? "#DD2E20" : i % 3 === 1 ? "#F4C734" : "#8BC547"} />
          </div>
        ))}
      </div>
    </section>
  );
}
